import React, { Component, Suspense } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { hotjar } from "react-hotjar";

import Loadable from "react-loadable";
import "../../node_modules/font-awesome/scss/font-awesome.scss";

import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../route";
import axios from "axios";
import ResetPassword from "../Demo/Authentication/ResetPassword";
import { connect } from "react-redux";
const AdminLayout = Loadable({
  loader: () => import("./layout/AdminLayout"),
  loading: Loader,
});
class App extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.props.history.listen((location, action) => {
      if (
        location.pathname === "/new-order/article/audience" ||
        location.pathname === "/new-order/article/presentive"
      ) {
        props.dispatch({ type: "RESET_ALL" });
      }
    });
  }
  componentDidMount() {
    hotjar.initialize(1816054, 6);
  }
  render() {
    const menu = routes.map((route, index) => {
      return route.component ? (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={(props) => <route.component {...props} />}
        />
      ) : null;
    });

    // const menu = routes.map((route, index) => {
    //   return route.component ? (
    //     <ProtectedRoute
    //       key={route.name}
    //       path={route.path}
    //       exact={route.exact}
    //       name={route.name}
    //       component={route.component}
    //     />
    //   ) : null;
    // });

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        //place your reentry code
        if (error.response.status === 401) {
          this.props.history.push("/login");
        }
        return Promise.reject(error);
      }
    );

    return (
      <Aux>
        <ScrollToTop>
          <Suspense fallback={<Loader />}>
            <Switch>
              {menu}
              <Route path="/" component={AdminLayout} />
              <Route component={() => <p>404</p>} />
              <Route path="/forget-password" component={ResetPassword} />
            </Switch>
          </Suspense>
        </ScrollToTop>
      </Aux>
    );
  }
}

export default withRouter(connect(null, null)(App));
